
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VendorTypeAccountModel } from '@/models/accounting/vendor';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { vendorService, storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  components: {
    AppDialog: () =>
      import('@/components/common/app.dialog.vue'),
  },
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class AddVendorTypeAccountPage extends Base {
  public dataCaptured: boolean = false;
  public addAccountModel: VendorTypeAccountModel = {
    accountNumber: '',
    vendorTypeNumber: '',
    id: 0,
    name: '',
    store: {},
    storeId: 0,
    storeName: '',
  };
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public accountId: number = 0;
  public isStoresLoading: boolean = false;
  public isAddAccountLoading: boolean = false;
  public isDMS: string = 'false';
  public showAddAccountTypeDMSPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t('vendorTypeAccount.btnAddAccountFromDMS') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('vendorTypeAccount.btnSubmit').toString(),
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.getAccountFromDMS();
    },
  };

  public created(): void {
    this.storeId = Number(this.$route.params.storeId);
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.vendortypeaccounts',
        params: { storeId: this.storeId.toString() },
      });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.addAccount();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('vendorTypeAccount.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('vendorTypeAccount.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'vendorTypeAccount');

    this.isDMS = this.$route.params.dms;

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.storeId = Number(this.$route.params.storeId);
    if (Number(this.storeId) !== 0) {
      this.getStores();
    }
    this.accountId = Number(this.$route.params.id);
    if (this.accountId) {
      this.getAccountDetails();
    }

    if (this.isDMS == 'true') {
      this.showAddAccountTypeDMSPopup.model = true;
    }
  }
  public setFields(): void {
    this.formFields = [
      {
        key: 'storeName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'vendorTypeAccount.vendorTypeAccountFields.storeName'
          ) as string,
          required: true,
          disabled: true,
          loading: false,
          rules: [
            v => this.required('Store Name', v)
          ]
        },
      },
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 100,
          label: this.$t(
            'vendorTypeAccount.vendorTypeAccountFields.name'
          ) as string,
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Name', v)
          ]
        },
      },
      {
        key: 'vendorTypeNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: this.$t(
            'vendorTypeAccount.vendorTypeAccountFields.vendorTypeNumber'
          ) as string,
          required: true,
          type: 'number',
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Vendor Type Number', v)
          ]
        },
      },
      {
        key: 'accountNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: this.$t(
            'vendorTypeAccount.vendorTypeAccountFields.accountNumber'
          ) as string,
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Account Number', v)
          ]
        },
      },
    ];
  }

  public async getAccountFromDMS(): Promise<void> {
    if (this.validateForm()) {
      try {
        this.isAddAccountLoading = true;
        this.$emit('update:progress', this.isAddAccountLoading);
        if (this.addAccountModel.id == 0) {
          const response = await vendorService.getAccountFromDMS(
            Number(this.addAccountModel.vendorTypeNumber),
            this.storeId
          );
          if (response.recordKey) {
            this.addAccountModel.vendorTypeNumber = response.recordKey.toString();
            this.addAccountModel.accountNumber = response.apAccount.toString();
            this.addAccountModel.name = response.description.toString();
            this.showAddAccountTypeDMSPopup.model = false;
          } else {
            this.showAlert(
              false,
              this.$t('vendorTypeAccount.accountFromDMSNotFound')
            );
          }
        }
      } finally {
        this.isAddAccountLoading = false;
        this.$emit('update:progress', this.isAddAccountLoading);
      }
    }
  }

  public validateAddAcount(): Vue & { validate: () => boolean } {
    return this.$refs.addAccountForm as Vue & { validate: () => boolean };
  }

  public async addAccount(): Promise<void> {
    if (this.validateAddAcount().validate()) {
      try {
        if (this.$validator.validateAll()) {
          this.isAddAccountLoading = true;
          this.$emit('update:progress', this.isAddAccountLoading);
          if (this.addAccountModel.id !== 0) {
            await vendorService.updateAccountAsync(
              this.addAccountModel,
              this.storeId
            );
            this.showAlert(
              true,
              this.$t('vendorTypeAccount.alertUpdateVendorTypeAccount')
            );
            this.$router.push({
              name: 'admin.vendortypeaccounts',
              params: { storeId: this.storeId.toString() },
            });
          } else {
            await vendorService.addAccountAsync(
              this.addAccountModel,
              this.storeId
            );
            this.showAlert(
              true,
              this.$t('vendorTypeAccount.alertSaveVendorTypeAccount')
            );
            this.$router.push({
              name: 'admin.vendortypeaccounts',
              params: { storeId: this.storeId.toString() },
            });
          }
        }
      } finally {
        this.isAddAccountLoading = false;
        this.$emit('update:progress', this.isAddAccountLoading);
      }
    }
  }

  public async getStores(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields, 'storeName');
      const response = await storeService.getStoresList();
      this.setStoreName(response.results);
    } finally {
      this.formlyHideSkeleton(this.formFields, 'storeName');
    }
  }
  public setStoreName(stores: any[]) {
    stores.forEach((store) => {
      if (store.id === this.storeId.toString()) {
        this.addAccountModel.storeId = store.id;
        this.addAccountModel.storeName = store.dealershipName;
      }
    });
  }
  public async getAccountDetails(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const response = await vendorService.getVendorTypeAccountAsync(
        this.storeId,
        this.accountId
      );
      this.addAccountModel = response;
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }
}
